import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Button } from '@common/components/Button/Button';
import { ButtonTypes } from '@common/components/Button/types';
import { HookFormInput } from '@common/components/FormInput/HookFormInput';
import { validateEmailAddresses } from '@common/utils/utils';
import * as Styled from './styles';

interface IAddEmailAddressForm {
  emailAddress: string;
}

interface IAddEmailAddressFormProps {
  onSubmit: (data: IAddEmailAddressForm) => void;
  isDisabled?: boolean;
}

export const AddEmailAddressForm = ({ onSubmit, isDisabled }: IAddEmailAddressFormProps) => {
  const form = useForm<IAddEmailAddressForm>({
    mode: 'onSubmit',
    defaultValues: {
      emailAddress: '',
    },
  });

  const {
    handleSubmit,
    formState: { errors },
  } = form;

  return (
    <FormProvider {...form}>
      <Styled.InputRow>
        <HookFormInput
          name="emailAddress"
          label=""
          rules={{
            required: 'Email address is required',
            validate: (value: string) => {
              const result = validateEmailAddresses(value);
              return result.valid || result.message || 'Invalid email address';
            },
          }}
          placeholder=""
          error={errors.emailAddress?.message?.toString()}
        />
        <Styled.ButtonWrapper>
          <Button
            type={ButtonTypes.SUCCESS}
            text="Add"
            height={36}
            onClick={handleSubmit(onSubmit)}
            disabled={isDisabled}
          />
        </Styled.ButtonWrapper>
      </Styled.InputRow>
    </FormProvider>
  );
};
